import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export class ScreenInteractiveLayer extends PIXI.Container implements StageLayer {

    public clickArea: PIXI.Sprite;

    constructor() {
        super();
        this.name = "interactiveLayer";
        this.createInteractiveArea();

    }

    onResize(): void {

    }

    public setInteractiveState(setOn: boolean): void {
        this.clickArea.interactive = setOn;
        this.clickArea.buttonMode = setOn;
        if(!setOn){
            this.clickArea.off('pointerdown');
        }

    }

    private createInteractiveArea(): void {
        this.clickArea = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.clickArea.name = "overlay";
        this.clickArea.tint = 0xffffff;
        this.clickArea.alpha = 0;
        this.clickArea.visible = true;

        this.clickArea.width = 2040;
        this.clickArea.height = 2040;
        this.clickArea.position.set(360, 360);
        this.clickArea.anchor.set(0.5, 0.5);
        this.addChild(this.clickArea);
    }


}